import { useId } from 'react'



export function useAgentReplyPreambleModel({
  agentBrand = 'SIA',
  agentName,
  thoughtSummary = null,
  thoughtDetails = [],
  thoughtStreaming = false,
  workflowTrace = null,
  avatarSrc = null,
  avatarAlt = '',
  showLeadIcon = true,
  expanded = false,
  onToggleExpand = null,
}) {
  const tracePanelId = useId()
  const rawDetails = Array.isArray(thoughtDetails)
    ? thoughtDetails.filter((s) => typeof s === 'string')
    : []
  const details = thoughtStreaming
    ? rawDetails
    : rawDetails.filter((s) => String(s).trim())
  const workflowSteps = Array.isArray(workflowTrace?.steps) ? workflowTrace.steps : []
  const hasCollapsibleTrace = workflowSteps.length > 0
  const hasInlineDetails = rawDetails.length > 0 && !hasCollapsibleTrace
  const hasTrace = hasCollapsibleTrace
  const interactive = typeof onToggleExpand === 'function' && hasCollapsibleTrace
  const hasLead = showLeadIcon && (interactive || !showLeadIcon)
  const rowAlign = showLeadIcon && interactive && expanded && hasTrace ? 'flex-start' : 'center'
  const rowGap = !showLeadIcon ? 0 : hasTrace && expanded ? 1 : 0.5

  return {
    tracePanelId,
    details,
    workflowSteps,
    workflowStatus: workflowTrace?.status,
    hasTrace,
    hasInlineDetails,
    interactive,
    hasLead,
    rowAlign,
    rowGap,
    agentBrand,
    agentName,
    avatarSrc,
    avatarAlt,
    thoughtSummary,
    thoughtStreaming,
    expanded,
    showLeadIcon,
    onToggleExpand,
  }
}
